import mixpanel from 'mixpanel-browser';
import { EnvironmentService } from '../../environment/environment-service';
import { HasDependencies, hashString } from '../api/types';

export class Mixpanel implements HasDependencies {
  public actions;

  constructor(readonly environmentService: EnvironmentService) {
    mixpanel.init(environmentService.environment.mixpanelToken, {
      api_host: 'https://panacloud-proxymixp.panalyt.com',
      track_pageview: 'full-url',
    });

    this.actions = {
      identify: (id: string) => {
        if (environmentService.isProd) {
          mixpanel.identify(id);
        }
      },
      track: (name: string, props: Record<string, any>) => {
        if (environmentService.isProd) {
          mixpanel.track(name, props);
        }
      },
      register: (props: Record<string, any>) => {
        if (environmentService.isProd) {
          mixpanel.register(props);
        }
      },
      unregister: (property: string) => {
        if (environmentService.isProd) {
          mixpanel.unregister(property);
        }
      },
      reset: () => {
        if (environmentService.isProd) {
          mixpanel.reset();
        }
      },
      people: () => mixpanel.people,
    };
  }

  public getDeps = () => [hashString([...this.environmentService.getDeps()])];
}
